module.exports = __webpack_public_path__ + "img/category-casino-hover.0e3fe096.png";